import { emitCustomEvent } from 'global/Application';
import { AppDataSource } from 'global/DataSources/AppDataSource';
import { bcbs_groupconfigurationsnapshotevent } from 'model/CRM';
import * as ICustomTypes from 'model/CRM.type';

interface IEmitEvent {
    item: ICustomTypes.Ibcbs_groupconfigurationsnapshoteventUpdate;
    creating?: boolean;
    promise?: Promise<bcbs_groupconfigurationsnapshotevent>;
    priority?: number;
    error?: unknown;
}

let eeQueue: IEmitEvent[] = [];

/**
 * Queues the item for when processing time
 */
export function EmitEventQueue(emitEvent: IEmitEvent) {
    if (!emitEvent.creating)
        eeQueue = eeQueue.filter(q => q.item.bcbs_groupconfigurationsnapshoteventid !== emitEvent.item.bcbs_groupconfigurationsnapshoteventid);

    eeQueue.push(emitEvent);
}

export function EmitEventProcess(dataSource: AppDataSource) {
    return new Promise(async (resolve, reject) => {

        // anything to process?
        const batch = [...eeQueue];

        eeQueue.length = 0;

        batch.forEach(ee => {
            if (!ee.promise)
                ee.promise = dataSource.updateConfigurationSnapshotEvent(ee.item)
        });
  
        for (const eventItem of batch) {
            try {
                await eventItem.promise;
            } catch (error) {

                (error as any).description = `Emit event failed for ${eventItem.item.bcbs_benefitname}/${eventItem.item.bcbs_categoryname}/${eventItem.item.bcbs_name}.`;
                (error as any).tag = JSON.stringify(eventItem.item);

                // requeue failed item
                delete eventItem.promise;
                eventItem.error = error;
                EmitEventQueue(eventItem);

                // lets create a new one is payload is not providing one
                emitCustomEvent({
                    eventType: 'globalException',
                    details: error,
                } as any);

                // for now let save continue
                // reject(error);
            }
        }

        resolve(null);
    });
}